/*
 * Public API Surface of lib-web-layout-templates
 */

export * from './lib/lib-web-layout-templates.service';
export * from './lib/lib-web-layout-templates.component';
export * from './lib/lib-web-layout-templates.module';
export * from './lib/sidebar-menu/sidebar-menu.component';
